export const getParentProperties = (task) => {
  const parent = window.ganttVisualization.getTask(task.parent);
  const activityRoute = parent?.activityReference
    ? parent.activityReference.activityRoute
    : parent.activityRoute;
  const parentName = parent?.activityReference
    ? parent.activityReference.name
    : parent.name;

  return [activityRoute, parentName];
};

export const getIsOdd = (task, column) => {
  let isOdd = false;
  if (
    window.ganttVisualization?.oddColsConfig &&
    task.type === 'activitytask'
  ) {
    isOdd = window.ganttVisualization.oddColsConfig[column.name];
  }

  return isOdd;
};
